import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 300_000,
      refetchOnWindowFocus: false,
      retry: (fails, err: any) => (String(err?.message).includes("HTTP 5") ? fails < 2 : false),
    },
    mutations: { retry: 0 },
  },
});
